module.exports = __webpack_public_path__ + "static/img/3-box.4d92601.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/3-box.png
// module id = nSPJ
// module chunks = 0